<template>
            <el-dialog
  title="提示"
  :visible.sync="dialogDeleteMsg.dialogDelete"
  width="30%"
  :before-close="handleClose">
  <span>确定要删除吗</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="isCancel">取 消</el-button>
    <el-button type="primary" v-if="dialogDeleteMsg.title=='keyworlds'" @click="isKeyWoldsDelete">确 定</el-button>
    <el-button type="primary" v-if="dialogDeleteMsg.title=='scholar'" @click="isDelete">确 定</el-button>
    <el-button type="primary" v-if="dialogDeleteMsg.title=='paper'" @click="ispaperDelete">确 定</el-button>
  </span>
</el-dialog>
</template>
<script>
export default {
    props:{dialogDeleteMsg:Object},
    data() {
        return {
            
        }
    },
    methods: {
        handleClose(){
           this.$emit('tabsCancel',false)
        },
        isCancel(){
            this.$emit('tabsCancel',false)
            // this.addMsg={}
        },
        // 
        isKeyWoldsDelete(){
           this.$emit('tabsKeyWoldsDelete',this.dialogDeleteMsg.data.ids[0])
        },
        isDelete(){
            this.$emit('tabsScholarDelete',this.dialogDeleteMsg)
            // this.addMsg={}
        },
        ispaperDelete(){
            this.$emit('ispaperDelete',this.dialogDeleteMsg)   
            // this.addMsg={}
        }
    },
}
</script>
<style lang="scss" scoped>
.el-dialog__footer {
    padding: 10px 25% 20px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: center;
      .el-button--default:hover {
        background: $base-color;
        color: $blueBtna;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/exploration/components/DialogDelete.vue